// DatePickerComponentWithTimeMobile.js
import React from "react";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  LocalizationProvider,
  MobileDateTimePicker,
} from "@mui/x-date-pickers";
import { Timestamp } from "firebase/firestore";
import dayjs from "dayjs";
import "../css/customDatePickerStyles.css";

export default function DatePickerComponentWithTimeMobile(props) {
  const handleChange = (date) => {
    const timestamp = Timestamp.fromMillis(date.valueOf());
    props.onChange(timestamp);
  };

  const dateObject =
    props.value && typeof props.value.toMillis === "function"
      ? dayjs(new Date(props.value.toMillis()))
      : props.value;

  return (
    <div className="input-label-container">
      <div className="input-label">
        {props.title}{" "}
        {props.isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MobileDateTimePicker
          inputFormat="DD/MM/YYYY HH:mm"
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              error={false}
              InputProps={{
                ...params.InputProps,
                style: {
                  padding: "8px",
                  fontSize: "16px",
                  height: 30,
                },
              }}
              sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "grey",
                },
              }}
            />
          )}
          value={dateObject}
          onChange={handleChange}
        />
      </LocalizationProvider>
    </div>
  );
}
